import script from "./dialog-delete.vue?vue&type=script&lang=ts&setup=true"
export * from "./dialog-delete.vue?vue&type=script&lang=ts&setup=true"

import "./dialog-delete.vue?vue&type=style&index=0&id=e07228a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e07228a0"]])

export default __exports__